import React from 'react'
import Styles from './style.module.css';
import { useSelector } from 'react-redux'
import { bindActionCreators } from 'redux';
import { Actions } from '../../Action';
import { useDispatch } from 'react-redux';
import VizData from './vizData';
import ExpertData from './ExpertData';

export default function DataTabs() {
const tagState = useSelector(state=>state.keyTag);
const dispatch = useDispatch();
const {getkeyTagPayload} = bindActionCreators(Actions, dispatch)
const onClickTab = (key)=>{
    if(tagState.tagSelectedPayload.key===key){
        return;
    }
    getkeyTagPayload({tag:tagState.tagSelectedPayload.tag,key:key})
}
  return (
    <>
    <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
        <div onClick={()=>onClickTab('expert')} className={tagState.tagSelectedPayload.key==='expert'?Styles.onSelectedtab:Styles.ohHovertab} style={{width:'47.5%', textAlign:'center'}}>Expert Responses</div>
        <div onClick={()=>onClickTab('viz')} className={tagState.tagSelectedPayload.key==='viz'?Styles.onSelectedtab:Styles.ohHovertab} style={{width:'47.5%', textAlign:'center'}}>User Queries</div>
    </div>
   { tagState.tagSelectedPayload.key==='viz' && <VizData/>}
   { tagState.tagSelectedPayload.key==='expert' && <ExpertData/>}

    </>
  )
}
